import classNames from 'classnames';
import React from 'react';
import { EIcon } from '../icon/icon';
import { TIconName } from '../icon/icon.types';
import './tag.scss';

export enum ETagColor {
	Orange = 'Orange',
	Red = 'Red',
}
const COLOR_MAP: Record<ETagColor, string> = {
	Orange: '#FF8164',
	Red: 'red',
};

interface TagProps {
	classNameTag?: string;
	text: string;
	color?: ETagColor;
	icon?: TIconName;
}
export const Tag: React.FC<TagProps> = ({ classNameTag, text, color, icon }) => {
	return (
		<div
			className={classNames(classNameTag, "tag-container")}
			style={ color? {backgroundColor: COLOR_MAP[color]} : undefined}
		>
			{icon && <EIcon name={icon} size={18} position="left" />}
			{text}
		</div>
	);
};
